import React from 'react';

var MobileMinMaxBet = function (_a) {
    var min = _a.min, max = _a.max, text = _a.text, currency = _a.currency;
    return (React.createElement("div", { className: 'pgc-m-game-txt-parent' },
        React.createElement("p", { className: 'pgc-m-game-bet-txt' }, text),
        React.createElement("p", { className: 'pgc-m-game-bet-txt-num' },
            min,
            " - ",
            max,
            " ",
            React.createElement("span", { className: 'pgc-m-game-bet-txt-num-txt' }, currency),
            " ")));
};

export { MobileMinMaxBet };
